document.addEventListener('DOMContentLoaded', () => { initLuxuryCart(); });
document.addEventListener('shopify:section:load', () => { initLuxuryCart(); });

function initLuxuryCart() {
  const root = document.getElementById('luxury-cart-root');
  if (!root) return;

  function updateQty(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: parseInt(qty) })
    }).then(() => window.location.reload()).catch(e => console.error(e));
  }

  root.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      const input = btn.closest('.cart-item-row').querySelector('.qty-input');
      let qty = parseInt(input.value);
      if (btn.classList.contains('qty-plus')) qty++;
      else if (btn.classList.contains('qty-minus') && qty > 0) qty--;
      input.value = qty;
      updateQty(btn.dataset.key, qty);
    });
  });

  root.querySelectorAll('.qty-input').forEach(input => {
    input.addEventListener('change', () => {
      const qty = parseInt(input.value);
      if (qty >= 0) updateQty(input.dataset.key, qty);
    });
  });

  root.querySelectorAll('.btn-remove-item').forEach(btn => {
    btn.addEventListener('click', e => { e.preventDefault(); updateQty(btn.dataset.key, 0); });
  });

  root.querySelectorAll('.cart-item-wishlist-link').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault(); e.stopPropagation();
      if (window.ShopifyWishlist && window.ShopifyWishlist.toggleItem) {
        window.ShopifyWishlist.toggleItem({
          id: btn.dataset.variantId || btn.dataset.productId,
          handle: btn.dataset.handle,
          title: btn.dataset.title || 'Product',
          price: btn.dataset.price || '',
          image: btn.dataset.image || '',
          url: btn.dataset.url || `/products/${btn.dataset.handle}`
        });
      }
      updateQty(btn.closest('.cart-item-row').dataset.key, 0);
    });
  });

  const couponInput = root.querySelector('#cart-coupon-input');
  const couponBtn = root.querySelector('#apply-coupon-trigger');
  if (couponInput && couponBtn) {
    couponBtn.addEventListener('click', e => {
      e.preventDefault();
      const code = couponInput.value.trim();
      if (code) window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
    });
    couponInput.addEventListener('keypress', e => {
      if (e.key === 'Enter') { e.preventDefault(); couponBtn.click(); }
    });
  }
}